import clsx from "clsx";

const SectionTitle = ({
  eyebrow,
  title,
  subtitle,
  align = "left",
  className = "",
}) => {
  const alignmentClasses = {
    left: "text-left",
    center: "text-center",
    right: "text-right",
  };

  return (
    <div className={clsx(alignmentClasses[align] || alignmentClasses.left, className)}>
      {eyebrow && (
        <p className="mb-2 text-sm font-semibold uppercase tracking-[0.2em] text-[#a87f49]">
          {eyebrow}
        </p>
      )}

      {title && (
        <h2 className="text-3xl font-semibold tracking-tight text-[#8B3A3A] md:text-4xl">
          {title}
        </h2>
      )}

      {subtitle && (
        <p className="mt-3 text-base leading-7 text-[#4b3d3d] md:text-lg">
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default SectionTitle;